var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-title"},[_c('gc-base-icon',{attrs:{"icon":_vm.icon,"size":"20"}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }